import { forwardRef } from 'react';
import { cn } from './utils/cn';

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
}

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center',
          'py-12 text-center',
          'bg-bg-tertiary/20 rounded-lg',
          'border border-dashed border-border-default',
          className
        )}
        {...props}
      >
        {icon && <div className="text-[24px] mb-1 opacity-40">{icon}</div>}
        {title && (
          <p className="text-text-tertiary text-[12px] italic">{title}</p>
        )}
        {description && (
          <p className="text-text-tertiary/50 text-[11px] max-w-[200px] mt-1">
            {description}
          </p>
        )}
        {action && <div className="mt-4">{action}</div>}
      </div>
    );
  }
);

EmptyState.displayName = 'EmptyState';
